function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 12c0 5.04-3.74 9.21-8.59 9.9-.46.07-.93.1-1.41.1-2.76 0-5.26-1.12-7.07-2.93A9.969 9.969 0 012 12C2 6.48 6.48 2 12 2c2.76 0 5.26 1.12 7.07 2.93A9.969 9.969 0 0122 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.83 10.23l-2.48 2.48 6.53 6.53c-.36.35-.75.67-1.16.96l-6.43-6.43-2.47 2.47 5.12 5.13c.11.11.18.25.21.39v.01c-.24.05-.49.1-.74.13-.32.05-.64.08-.97.09L7.76 17.3l-2.28 2.28a8.74 8.74 0 01-.55-.51 8.74 8.74 0 01-.51-.55l14.1-14.1c.19.16.37.33.55.51.18.18.35.36.51.55l-3.69 3.69 5.69 5.69c-.16.53-.36 1.03-.6 1.52l-6.15-6.15z"
})));